import { useElements, useStripe, CardElement } from '@stripe/react-stripe-js';
import {
    HiOutlineCreditCard,
    HiOutlineInformationCircle,
} from "react-icons/hi";
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import toast from 'react-hot-toast';

const CheckOut = ({booking}) => {
    const [cardError, setCardError] = useState('');
    const [success, setSuccess] = useState('');
    const [processing, setProcessing] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [submitLoading, setSubmitLoading] = useState(false);
    const [transactionId, setTransactionId] = useState('');
    const [clientSecret, setClientSecret] = useState("");
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();


    const { _id,
        productID,
        product,
        buyerName,
        email,
        price,
        phone,
        location,
        buyer_id,
        seller_id,
        seller_email,
        booking_date
    } = booking;

    useEffect(() => {
        // Create PaymentIntent as soon as the page loads
        fetch(`${process.env.REACT_APP_API_URL}/create-payment-intent`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                authorization: `bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({ price }),
        })
            .then((res) => res.json())
            .then((data) => setClientSecret(data.clientSecret));
    }, [price]);

    const handleSold = (id) => {
        fetch(`${process.env.REACT_APP_API_URL}/products/sold/${id}`, {
            method: "PUT",
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.modifiedCount > 0) {
                    toast.success("paid successful.");
                    
                }
            });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            return
        }

        const card = elements.getElement(CardElement);
        if (card === null) {
            return;
        }
        setSubmitLoading(true);

        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card
        });

        if (error) {
            console.log(error);
            setCardError(error.message);
            setErrorMessage(error.message);
        }
        else {
            setCardError('');
            setErrorMessage('');
            console.log(paymentMethod);
        }
        setSuccess('');
        setProcessing(true);
        const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(
            clientSecret,
            {
                payment_method: {
                    card: card,
                    billing_details: {
                        name: buyerName,
                        email: email,
                        phone: phone
                    },
                },
            },
        );

        if (confirmError) {
            setCardError(confirmError.message);
            return;
        }
        if (paymentIntent.status === "succeeded") {
            
            // store payment info in the database
            const payment = {
                price: price,
                transactionId: paymentIntent.id,
                email: email,
                bookingId: _id,
                buyer_id: buyer_id,
                seller_id: seller_id,
                seller_email: seller_email,
                productID: productID,
                product: product,
                location: location,
                booking_date: booking_date,
                paymentMethod: paymentMethod,
            }
            fetch(`${process.env.REACT_APP_API_URL}/payments`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    authorization: `bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify(payment)
            })
                .then(res => res.json())
                .then(data => {
                    if (data.insertedId) {
                        setSubmitLoading(false);
                        navigate("/dashboard/orders");
                        setSuccess('Congrats! your payment completed');
                        setTransactionId(paymentIntent.id);
                    } else {
                        setSubmitLoading(false);
                        toast.error(data.message);
                    }
                })
        }
        setProcessing(false);
    }
    return (
        <>
            <form onSubmit={handleSubmit}>
                <CardElement
                    options={{
                        style: {

                            base: {
                                fontSize: '16px',
                                color: '#424770',
                                '::placeholder': {
                                    color: '#aab7c4',
                                },
                            },
                            invalid: {
                                color: '#9e2146',
                            },
                        },
                    }}
                />

                <button
                    className='btn btn-sm mt-4 btn-primary'
                    type="submit"
                    onClick={() => handleSold(productID)}
                    disabled={!stripe || !clientSecret || processing || submitLoading }
                >
                    {submitLoading ? (
                        <div className="flex justify-center items-center">
                            <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-gray-200 mr-2"></div>
                        </div>
                    ) : (
                        <HiOutlineCreditCard className="mr-2" />
                    )}
                    {submitLoading ? "Processing..." : "Pay"}
                </button>
            </form>
            {errorMessage && (
                <div className="pt-5 flex justify-center items-center text-red-600">
                    <HiOutlineInformationCircle className="mr-2" />
                    {errorMessage}
                </div>
            )}
            <p className="text-red-500">{cardError}</p>
            {
                success && <div>
                    <p className='text-green-500'>{success}</p>
                    <p>Your transactionId: <span className='font-bold'>{transactionId}</span></p>
                </div>
            }
        </>
    );
};

export default CheckOut;